import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CoreCommonModule } from '@core/common.module';
import { CoreSidebarModule } from '@core/components';
import { CoreTouchspinModule } from '@core/components/core-touchspin/core-touchspin.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { ColorPickerModule } from 'ngx-color-picker';
import { SigningServiceHttp } from 'app/main/signing-pages/signing-service';
import { QRCodeModule } from 'angularx-qrcode';
import { SharedModule } from '../shared/shared/shared.module';
import { TranslocoDirective } from '@jsverse/transloco';
import { OnlineContractComponent } from './online-contract/online-contract.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { featureKey } from './online-contract/store/state/online-contract.state';
import { onlineContractReducer } from './online-contract/store/reducer/online-contract.reducer';
import { OnlineContractEffects } from './online-contract/store/effects/online-contract.effects';
import { AgreeTermsAndConditionsComponent } from './agree-terms-and-conditions/agree-terms-and-conditions.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import {CreditSafeInfoFetcherComponent} from "./add-ons/credit-safe/credit-safe-info-fetcher.component";
import {CreditSafeCreditCheckerComponent} from "./add-ons/credit-safe/credit-safe-credit-checker.component";

const appRoutes: Routes = [
    {
        path: '',
        component: OnlineContractComponent,
        data: { signingArea: true, is_sender: 0 },
    },
]
@NgModule({
  declarations: [
    OnlineContractComponent,
    AgreeTermsAndConditionsComponent
  ],
  imports: [
    CommonModule,
    CoreCommonModule,
    ContentHeaderModule,
    NgbModule,
    NgSelectModule,
    ColorPickerModule,
    CoreTouchspinModule,
    NgScrollbarModule,
    CoreSidebarModule,
    QRCodeModule,
    SharedModule,
    TranslocoDirective,
    RouterModule.forChild(appRoutes),
    StoreModule.forFeature(featureKey, onlineContractReducer),
    EffectsModule.forFeature([OnlineContractEffects]),
    CreditSafeInfoFetcherComponent,
    CreditSafeCreditCheckerComponent,
  ],
  exports: [
    AgreeTermsAndConditionsComponent
  ],
  providers: [SigningServiceHttp]
})
export class OnlineContractModule {}
